import React from "react";
import { BreadcrumbItem } from "reactstrap";
import { Route, Switch, Link } from "react-router-dom";
import * as NewRoute from "./new";
import * as ListRoute from "./list";
import * as SiteRoute from "./site";
import SitePublicSchema from "@common/schema/site/public";
import * as Section from "@repoflow/components/section";

// `Section` here is the routing/form primitive every screen is wrapped in — not
// the entity. They share a word and nothing else.
const LocalProvider = ({
  match: {
    params,
  },
  children: Children,
}) => {
  const base = `/site`;
  const basepath = `/site`;

  return (
    <Section.Provider
      schema={SitePublicSchema}
      base={base}
      basepath={basepath}
      attributes={params}
    >
      {/* Called, never rendered as an element — see Section.Provider. */}
      {Children({ base, basepath, params })}
    </Section.Provider>
  );
};

export function Content(props) {
  return (
    <LocalProvider {...props}>
      {({ basepath }) => (
        <Switch>
          <Route path={`${basepath}/new`} component={NewRoute.Content} />
          <Route path={`${basepath}/:siteId`} component={SiteRoute.Content} />
          <Route path={`${basepath}/`} component={ListRoute.Content} />
        </Switch>
      )}
    </LocalProvider>
  );
}

export function Indice(props) {
  return (
    <LocalProvider {...props}>
      {({ base, basepath }) => (
        <>
          <BreadcrumbItem>
            <Link to={base}>Sites</Link>
          </BreadcrumbItem>
          <Switch>
            <Route path={`${basepath}/new`} component={NewRoute.Indice} />
            <Route path={`${basepath}/:siteId`} component={SiteRoute.Indice} />
            <Route path={`${basepath}/`} component={ListRoute.Indice} />
          </Switch>
        </>
      )}
    </LocalProvider>
  );
}

export const Sidebar = () => <></>;
